export default "__VITE_ASSET__DsIF50nF__"